(()=>{'use strict';
const html=document.documentElement;
const reduced=window.matchMedia('(prefers-reduced-motion: reduce)');
let ticking=false;
function updateHeader(){
  ticking=false;
  const page=document.querySelector('.page-wrapper');
  const y=Math.max(window.scrollY||0,page?.scrollTop||0);
  html.classList.toggle('topg-is-scrolled',y>38);
}
function scheduleScroll(){
  if(ticking)return;
  ticking=true;
  window.requestAnimationFrame(updateHeader);
}
function initReveals(){
  if(html.classList.contains('shopify-design-mode')||reduced.matches||
     !('IntersectionObserver' in window)||!Element.prototype.animate)return;
  const targets=[
    '#topg-best-sellers .topg-best-stack__head',
    '#topg-best-sellers .topg-best-grid__head',
    '#topg-shop-collections .topg-collections-v11__head',
    '#topg-shop-collections .topg-collection-card-v11',
    '#topg-new-arrivals .topg-new-v4__head',
    '#topg-customer-gallery .topg-section-intro',
    '#topg-watch-finder .topg-finder-copy',
    '#topg-faq .topg-section-intro',
    '#topg-community > h2',
    '.topg-gallery-page__hero'
  ].join(',');
  const tracked=new WeakSet();
  const observer=new IntersectionObserver(entries=>{
    for(const entry of entries){
      if(!entry.isIntersecting)continue;
      observer.unobserve(entry.target);
      if(!entry.target.isConnected||document.hidden||reduced.matches)continue;
      try{
        entry.target.animate(
          [{opacity:.97,translate:'0 7px'},{opacity:1,translate:'0 0'}],
          {duration:window.matchMedia('(max-width:749px)').matches?260:340,
           easing:'cubic-bezier(.22,.7,.25,1)',fill:'none'}
        );
      }catch(_){/* Preserve fully visible content. */}
    }
  },{rootMargin:'0px 0px -4% 0px',threshold:.06});
  function register(root){
    if(!root?.querySelectorAll)return;
    const elements=[];
    if(root.matches?.(targets))elements.push(root);
    elements.push(...root.querySelectorAll(targets));
    for(const element of elements){
      if(tracked.has(element))continue;
      tracked.add(element);
      const rect=element.getBoundingClientRect();
      if(!rect.width||!rect.height||rect.bottom<=0||rect.top<window.innerHeight*.9)continue;
      observer.observe(element);
    }
  }
  register(document);
  document.addEventListener('shopify:section:load',e=>{
    if(e.target)register(e.target);
    scheduleScroll();
  });
  reduced.addEventListener?.('change',()=>{
    if(reduced.matches)observer.disconnect();
    else register(document);
  });
}
function init(){
  const page=document.querySelector('.page-wrapper');
  window.addEventListener('scroll',scheduleScroll,{passive:true});
  page?.addEventListener('scroll',scheduleScroll,{passive:true});
  window.addEventListener('pageshow',scheduleScroll);
  updateHeader();
  initReveals();
}
if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',init,{once:true});
else init();
})();